import React from 'react'
export default React.createContext({
    username: '',
    organization_id: '',
    first_name: '',
    signature: '',
    gemalto_enabled: '',
    sessionToken: '',
})
